import { formatMoneyDisplay } from "@client/lib/format";
import { type Kpi } from "./types";

export const formatValue = (kpi: Kpi.Api.KpiType, value: number | undefined | null): any => {
  if (!value) return 0;

  switch (kpi) {
    case "NetworkVolume":
    case "Spend": {
      return formatMoneyDisplay(value);
    }
  }

  return value;
};
